
















import Vue from 'vue'

export default Vue.extend({
  name: 'DatePicker',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    year: {
      type: Number,
      default: null
    },
    month: {
      type: Number,
      default: null
    },
    date: {
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      y: this.year,
      m: this.month,
      d: this.date,
      maximums: {
        year: 0,
        month: 12,
        date: 31
      },
      minimums: {
        year: 1,
        month: 1,
        date: 1
      }
    }
  },
  computed: {
    ICON_SIZE(): number {
      return 20
    }
  },
  watch: {
    y(val) {
      this.$emit('update:year', val)
      this.$emit('input', val)
    },
    m(val) {
      this.$emit('update:month', val)
      this.$emit('input', val)
    },
    d(val) {
      this.$emit('update:date', val)
      this.$emit('input', val)
    }
  },
  created() {
    const date = new Date()
    if (!this.year) {
      this.y = date.getFullYear()
    }
    if (!this.month) {
      this.m = date.getMonth() + 1
    }
    if (!this.date) {
      this.d = date.getDate()
    }

    this.maximums.year = date.getFullYear()
  }
})
